import { httpClient } from '@/api/httpClient';
import type { StationReadiness } from './types';

export const onboardingApi = {
  getStationReadiness(stationId: string | number) {
    return httpClient<StationReadiness>(`/api/v1/stations/${stationId}/readiness/`);
  }
};
